import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useReveal from "./hooks/useReveal";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Cakes from "./components/Cakes";
import Marquee from "./components/Marquee";
import MenuSection from "./components/MenuSection";
import Story from "./components/Story";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import VideoReel from "./components/VideoReel";
import ChatWidget from "./components/ChatWidget";
import InstallPWA from "./components/InstallPWA";
import BackgroundMusic from "./components/BackgroundMusic";
import SplashScreen from "./components/SplashScreen";

const Home = () => {
  useReveal();
  return (
    <div className="grain-bg" style={{ overflowX: "clip" }}>
      <SplashScreen />
      <Navbar />
      <main>
        <Hero />
        <Cakes />
        <Marquee />
        <MenuSection />
        <Story />
        <Gallery />
        <Contact />
        <VideoReel />
      </main>
      <Footer />
      <ChatWidget />
      <InstallPWA />
      <BackgroundMusic />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
